export enum MethodCode {
  C = 'C',
  E = 'E',
  M = 'M'
}
